import React, { useState } from 'react';
import fremtidensmad from '../../images/gameon.jpg';  // Import the image
import { useNavigate } from 'react-router-dom';


const stockSymbols = [
  { symbol: 'EMBRAC-B.ST', name: 'Embracer Group B' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'SF.ST', name: 'Stillfront Group' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'STAR-B.ST', name: 'Starbreeze B' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'PDX.ST', name: 'Paradox Interactive' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'G5EN.ST', name: 'G5 Entertainment' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'RBLX', name: 'Roblox A' }, // NYSE (US)
  { symbol: 'STVA-B.ST', name: 'Star Vault B' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'UBI.PA', name: 'Ubisoft Entertainment SA' }, // Euronext Paris (France)
  { symbol: 'EA', name: 'Electronic Arts' }, // NASDAQ (US)
  { symbol: '5PG.OL', name: '5th Planet Games' }, // Oslo Børs (Norway)
  { symbol: 'REMEDY.HE', name: 'Remedy Entertainment' }, // Nasdaq Helsinki (Finland)
  { symbol: 'MSFT', name: 'Microsoft' }, // NASDAQ (US)
  { symbol: 'TCEHY', name: 'Tencent Holdings Ltd.' }, // OTC Markets (US)
  { symbol: 'SE', name: 'Sea ADR A' }, // NYSE (US)
  { symbol: 'SOHU', name: 'Sohu.com ADR' }, // NASDAQ (US)
  { symbol: 'GRVY', name: 'Gravity ADR' }, // NASDAQ (US)
  { symbol: 'MAGI.ST', name: 'MAG Interactive' }, // Nasdaq Stockholm (Sweden)
  { symbol: 'TTWO', name: 'Take-Two Interactive Software' }, // NASDAQ (US)
  { symbol: 'SONY', name: 'Sony ADR' }, // NYSE (US)
  { symbol: 'NIPG', name: 'NIP Group' }, // NASDAQ (US)
  { symbol: 'GME', name: 'GameStop' }, // NYSE (US)
  { symbol: 'NITRO.ST', name: 'Nitro Games' }, // Nasdaq First North Growth Market (Sweden)
  { symbol: 'QIIWI.ST', name: 'Qiiwi Games' }, // Nasdaq First North Growth Market (Sweden)
  { symbol: 'TGAMES.CO', name: 'Trophy Games Development' }, // Nasdaq First North Growth Market (Denmark)
  { symbol: 'GAW.L', name: 'Games Workshop Group plc' }, // London Stock Exchange (UK)
]




function FintechCard16() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [stocks, setStocks] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleCardClick = async () => {
    setLoading(true);
    setIsModalOpen(true);
    try {
      const symbolsToFetch = stockSymbols.map(stock => stock.symbol);
      console.log('Fetching symbols:', symbolsToFetch);

      const stockPromises = symbolsToFetch.map(async symbol => {
        try {
          const response = await fetch(`https://investorverden.onrender.com/api/stocks?q=${symbol}`);
          if (!response.ok) throw new Error(`Failed to fetch ${symbol}`);
          return await response.json();
        } catch (error) {
          return { error: `Symbol failed: ${symbol}` };
        }
      });

      const results = await Promise.all(stockPromises);
      console.log('Raw results:', results);

      const processedStocks = results.map(result => {
        // If there's an error property
        if (result.error) {
          return {
            logo: '',
            name: result.error,
            price: '-',
            changePercent24h: '-',
            isPositive: false,
            marketCap: '-',
            currency: '-',
          };
        }
        const { stockData: sd } = result;
        if (!sd) {
          return {
            logo: '',
            name: 'No data',
            price: '-',
            changePercent24h: '-',
            isPositive: false,
            marketCap: '-',
            currency: '-',
          };
        }
        const matchingSymbol = stockSymbols.find(s => s.symbol === sd.symbol);
        return {
          logo: sd.logo_url || '',
          name: matchingSymbol?.name || sd.shortName || sd.symbol,
          price: sd.regularMarketPrice?.toFixed(2) || '0.00',
          changePercent24h: sd.regularMarketChangePercent?.toFixed(2) || '0.00',
          isPositive: parseFloat(sd.regularMarketChangePercent) > 0,
          marketCap: sd.marketCap
            ? (sd.marketCap / 1000000000).toFixed(2) + 'B'
            : 'N/A',
          currency: sd.currency || 'USD',
        };
      });

      console.log('Processed stocks:', processedStocks);
      setStocks(processedStocks);
    } catch (error) {
      console.error('Error:', error);
      setStocks([]);
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <div
        className="flex flex-col col-span-full sm:col-span-6 xl:col-span-3 bg-white dark:bg-gray-800 shadow-sm rounded-xl cursor-pointer"
        onClick={handleCardClick}
      >
        <div className="px-5 pt-5">
          <header>
            <h3 className="text-sm font-semibold text-gray-500 uppercase mb-1">
              <span className="text-gray-800 dark:text-gray-100">Game on!</span>
            </h3>
          </header>
        </div>
        <div className="grow">
          <img src={fremtidensmad} alt="Fremtidens mad" className="w-full h-auto rounded-b-xl" />
        </div>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
          <div
            className="bg-white dark:bg-gray-800 p-5 rounded-lg shadow-lg w-full max-w-4xl"
            style={{ maxHeight: '80vh', overflowY: 'auto' }}
          >
            <h2 className="text-l font-semibold mb-4">Game on!</h2>
            <p className="text-sm text-gray-700 dark:text-gray-200">
            Selskaber, som producerer og udvikler computerspil
            <br />
            </p>
            {loading ? (
              <div className="flex justify-center items-center h-48">
                <svg
                  className="animate-spin h-10 w-10 text-violet-500"
                  xmlns="http://www.w3.org/2000/svg"  
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v8H4z"
                  ></path>
                </svg>
              </div>
            ) : (
              <table className="w-full text-left">
                <thead>
                  <tr className="border-b">
                    <th className="px-2 py-1">Logo</th>
                    <th className="px-2 py-1">Selskab</th>
                    <th className="px-2 py-1">I dag</th>
                    <th className="px-2 py-1">Børsværdi</th>
                  </tr>
                </thead>
                <tbody>
                  {stocks.map((stock, index) => (
                    <tr key={index} className="border-b">
                      <td className="px-2 py-2">
                        {stock.logo ? (
                          <img src={stock.logo} alt={stock.name} className="w-6 h-6" />
                        ) : (
                          <span>N/A</span>
                        )}
                      </td>
                      <td className="px-2 py-2">
                        {stock.name}: {stock.currency}
                      </td>
                      <td
                        className={`px-2 py-2 ${
                          stock.isPositive ? 'text-green-500' : 'text-red-500'
                        }`}
                      >
                        {stock.changePercent24h}%
                      </td>
                      <td className="px-2 py-2">{stock.marketCap}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            <button
              className="mt-4 px-4 py-2 bg-violet-500 text-white rounded"
              onClick={closeModal}
            >
              Luk
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default FintechCard16;